import { api } from '@/shared/api/axios';
import { unwrapList } from '@/shared/api/unwrap';

const base = (depId) => `/deployments/${depId}/shifts`;

export const shiftsApi = {
  list: (depId) => api.get(base(depId)).then(unwrapList),

  create: (depId, payload) =>
    api.post(base(depId), payload).then((r) => r.data),

  update: (depId, shiftId, payload) =>
    api.patch(`${base(depId)}/${shiftId}`, payload).then((r) => r.data),

  delete: (depId, shiftId) =>
    api.delete(`${base(depId)}/${shiftId}`).then((r) => r.data),
};
